import React, { useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';

import { Button } from 'app/src/elements/buttons';
import { Text, Title } from 'app/src/styles';
import { datetimeMedium } from 'app/src/utils/formatting';

import { NOTES } from 'app/src/components/Notes/queries';

import { DOWNLOAD_SHOPIFY_CUSTOMERS } from './queries';

const Shopify = () => {
  const { data, refetch } = useQuery(NOTES, {
    fetchPolicy: 'no-cache',
    variables: {
      limit: 10,
      offset: 'MA==',
      options: {
        sort: 'id',
        sortDirection: 'desc',
        scopes: ['shopify_customers']
      }
    }
  });

  const [downloadShopifyCustomers] = useMutation(DOWNLOAD_SHOPIFY_CUSTOMERS);

  const handleDownloadCustomers = () => {
    const confirmation =
      'This will start a download of the customers list. It will take ' +
      '5 to 10 minutes. You will need to refresh this page to see if it is ' +
      'completed.';

    if (window.confirm(confirmation)) {
      downloadShopifyCustomers();
    }
  };

  const note = data?.notes.edges[0]?.node;

  return (
    <View>
      <Title>Shopify Data</Title>

      {note && (
        <Text>Last customer list update: {datetimeMedium(note.createdAt)}</Text>
      )}

      <Button
        style={{ width: 500 }}
        label="Download new customers list (will take 5-10 minutes)"
        onPress={handleDownloadCustomers}
      />
    </View>
  );
};

export default Shopify;
